import React, { Fragment, useState, useEffect, useContext } from 'react';
import propTypes from 'prop-types';
import Images from 'assets/images/imageData';
import Layout from 'components/sales/layout/layout';
import DivLayout from 'components/sales/divLayout/divLayout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import DocumentView from 'components/sales/downloadDocView/documentView';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import ComplaintReplySupport from 'components/sales/ListFilters/ComplaintReplySupport';
import { toast } from 'react-toastify';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
const headers = ['Ticket ID', 'Assigned To', 'Created On', 'Status', 'Actions'];
const ViewIssue = ({
  complainRaisedTicket,
  closeComplain,
  reopenComplain,
  match,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  history,
  saveAssigneeDetails,
  subIssueDropdown,
  getSubIssueDropdown = [],
  fetchAllIssuesList,
  getAllIssuesListing = [],
  saveRaiseIssueSupport,
  saveRaiseIssueReply = [],
}) => {
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [complainId, setComplainId] = useState(false);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSuccessFor, setIsSuccessFor] = useState('');
  const [ticketData, setTicketData] = useState('');
  const [status, setStatus] = useState('');
  const [internalStatus, setInternalStatus] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isReply, setIsReply] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [replyStatus, setReplyStatus] = useState(false);

  const source = 'LeadX'

  const compId = { complain_id: complainId };
  const handleIsConfirmation = () => {
    setIsConfirmation(!isConfirmation);
  };
  const handleIsSuccess = () => {
    setIsSuccess(!isSuccess);
  };
  const filterToggle = () => {
    setShowFilter(!showFilter);
};
const handleIsReply = () => {
  setIsReply(!isReply);
  history.push(`${baseUrl}/raise-issue-list`);
};
  const handleRaiseTicket = async () => {
    setIsLoading(true);
    await complainRaisedTicket(compId);
    await fetchAllIssuesList(null, 1, match.params.id);
    setIsLoading(false);
    setIsSuccessFor(localization.raiseTicket);
    handleIsSuccess();
  };
  const handleCloseComplain = async () => {
    await closeComplain(compId);
    setIsLoading(true);
    await fetchAllIssuesList(null, 1, match.params.id);
    setIsLoading(false);
    setIsSuccessFor(localization.closeComplain);
    handleIsConfirmation();
    handleIsSuccess();
  };
  const handleReopen = (val) => {
    if(val){
      (async () => {
        await reopenComplain(compId);
        setIsLoading(true);
        await fetchAllIssuesList(match.params.id);
        setIsLoading(false);
        setIsSuccessFor(localization.closeComplain);
        handleIsSuccess();
      })();
    }
    
  }
 
  useEffect(() => {
    setComplainId(match.params.id);
  }, [match]);
  useEffect(() => {
    if (getAllIssuesListing !== null) {
      setTicketData(getAllIssuesListing);
      setStatus(getAllIssuesListing?.status);
      setInternalStatus(getAllIssuesListing?.internal_status);
      const tableData = ['id', 'assigned_to', 'created_at', 'status'];
      if (getAllIssuesListing && getAllIssuesListing?.rm_ticket) {
        const data = getAllIssuesListing?.rm_ticket?.map((element) =>
          Object.assign(
            {},
            ...tableData.map((key) => ({ [key]: element[key] })),
            {
              Actions: {
                name: 'View Details',
                link: `/dashboard/rm-view/${element.id}`,
              },
            }
          )
        );
        setListData(data);
      }
    }
  }, [getAllIssuesListing]);
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await fetchAllIssuesList(null, 1, match.params.id);
      setIsLoading(false);
    })();
  }, [fetchAllIssuesList, match.params.id]);
  const successIconBox = (text) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>
          {isSuccessFor === localization.raiseTicket
            ? localization.ticketSuccessfullyCreated
            : localization.complainClosedSuccessfully}
        </h5>
        <Button onClick={handleIsSuccess} className="btn btn-primary">
          {localization.continue} <img src={Images?.ArrowRight} alt="" />
        </Button>
      </div>
    );
  };

  const applyFilter = async (filterData) => {
    if(filterData.message == '' || filterData.message == null) {
       toast.error('Please enter message.');
       return false;
    }
    if(filterData.isClosed === true && filterData.issue_related_to == '' && source !== 'LeadX' ) {
      toast.error('Issue is required.');
      return false; 
    }

    if(filterData.isClosed === true && filterData.rca == ''  && source !== 'LeadX') {
      toast.error('RCA is required.');
      return false; 
    }
    setIsLoading(true);
    setFilterData(filterData);
    const res = await saveRaiseIssueSupport(filterData,match.params.id);
    setIsLoading(false);
    if(res) {
      setIsReply(true);
    }
    filterToggle();
  };

  const assignInputs = {
    assigned_to:'',
    assignee_remark:'',
    complaint_id: '',
    message_from: '',
    send_to: '',
  };
  
  const [selectedAssignTo, setSelectedAssignTo] = useState(assignInputs);
  
  const handleAssignToSubmit = async () => {
    selectedAssignTo.complaint_id = ticketData.id;
    selectedAssignTo.message_from = ticketData.internal_status === "L2 Pending" ? "L2" : ticketData.internal_status === "CT Pending" ? "CT" : undefined;
    selectedAssignTo.send_to = ticketData.internal_status === "L2 Pending" ? "CT" : ticketData.internal_status === "CT Pending" ? "L2" : undefined;
  
    if(selectedAssignTo.assigned_to === '' || selectedAssignTo.assigned_to === null) {
      toast.error('Please select assignee.');
      return false;
    }
  
    setIsLoading(true);
    setFilterData(filterData); 
    const res = await saveAssigneeDetails(selectedAssignTo);
    setIsLoading(false);
  
    if(res) {
      setIsReply(true);
    }
  };
  
  const headerBtns = () => {
    return (
      <>
        {getAllIssuesListing &&
          getAllIssuesListing?.resultSets &&
          getAllIssuesListing?.resultSets[0] &&
          getAllIssuesListing?.resultSets[0]?.internal_status !== 'Closed' && (
            <Fragment>
              <Button
                onClick={filterToggle}
                className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
              >
                <img src={Images?.SelectMenu} alt="" />
                <b className="site_filters" style={{ width: "max-content" }}>
                  {`Reply`}
                </b>
              </Button>
            </Fragment>
          )}
      </>
    );
  };
  


  return (
    <Fragment>
      <Layout
        title={'View Ticket'}
        Buttons={headerBtns}  
        isLoading={isLoading}
        isGoback={true}
        linkFlag
        linkUrl={'/dashboard/raise-issue-list'}
      >
        {ticketData && ticketData?.resultSets?.length > 0 && ticketData?.resultSets?.map((ticket) => (
          <>
            <PanelCardWithHeading
                title={'Ticket Details'}
                status={ticket?.internal_status}
                key={ticket.id} // assuming there is an 'id' field in the 'ticket' object
            >
                <div className="details-listing">
                    <DivLayout
                        heading={'Ticket Id'}
                        data={ticket?.id}
                    />
                    <DivLayout
                        heading={'Raised By Name'}
                        data={ticket?.user_name}
                    />
                    <DivLayout
                        heading={'Raised By Email'}
                        data={ticket?.user_email}
                    />
                    <DivLayout
                        heading={'Raised By Mobile Number'}
                        data={ticket?.phone_number}
                    />
                    {/* <DivLayout
                        heading={localization.complainRaisedBy}
                        data={ticket?.user_email}
                    /> */}
                    <DivLayout
                        heading={'Status'}
                        data={ticket?.internal_status}
                    />
                    <DivLayout
                        heading={'Issue Description'}
                        data={ticket?.complain_description}
                    />
                    <DivLayout
                        heading={localization.createdOn}
                        data={ticket?.created_at}
                    />
                    <DivLayout
                        heading={localization.createdOn}
                        data={ticket?.created_at}
                    />
                    <DocumentView
                        attachment={ticket?.attachment}
                        key={document.id}
                    />
                </div>
            </PanelCardWithHeading>
            {(ticket?.l2_reply || ticket?.l2_attachment) && (
              <PanelCardWithHeading
                title={'L2 Details'}
              >
                <div className="details-listing">
                  {ticket?.l2_reply && (
                    <DivLayout
                        heading={'L2 Reply'}
                        data={ticket?.l2_reply}
                    />
                  )} 
                  {ticket?.l2_attachment && (
                    <DocumentView
                        attachment={ticket?.l2_attachment}
                        key={document.id}
                    />
                  )} 
                </div>
              </PanelCardWithHeading>
            )}
            </>
        ))}




            {/* Messages start */}
            
      {ticketData &&
        ticketData?.messageData &&
        ticketData?.messageData?.map((messageDatas) => ( 

            <PanelCardWithHeading title={`Replied By : `+messageDatas?.message_from+` ( ` +messageDatas?.created_at+ ` )`} colorChange={messageDatas?.message_from == 'Client' && '#fff3f3'}>
              <div className="details-listing">
                <DivLayout heading={`Send To`} data={messageDatas?.send_to} />
                {messageDatas?.rm_ticket_id !== null && messageDatas?.rm_ticket_id !='' ? (  
                  <DivLayout
                    heading={`Ticket Id`}
                    data={messageDatas?.rm_ticket_id}
                  />
                ): 
                  <DivLayout
                    heading={`Created By`}
                    data={(messageDatas?.name !== null) ? messageDatas?.name : 'Client'}
                  />
                }
                {messageDatas?.document && (messageDatas?.document?.map((documentss) => (
                  <DocumentView attachment={documentss} />
                )))}
                <DivLayout
                  heading={`Message`}
                  data={messageDatas?.message}
                />
                {messageDatas?.issue_name !== null && messageDatas?.issue_name != '' && (
                  <DivLayout
                    heading={`Issue Type`}
                    data={messageDatas?.issue_name}
                  />
                )}

                {messageDatas?.sub_issue_name !== null && messageDatas?.sub_issue_name != '' && (
                  <DivLayout
                    heading={`Sub-issue Type`}
                    data={messageDatas?.sub_issue_name}
                  />
                )}

                {messageDatas?.rm_ticket ? 
                <table className='panel-table table table-striped table-bordered'>
                  <thead>
                    <th>Assigned To</th>
                    <th>Status</th>
                    <th>Action</th>
                  </thead>
                  <tbody>
                  {messageDatas?.rm_ticket && (messageDatas?.rm_ticket?.map((rmData) => (
                    
                      <tr>
                        <td>{rmData?.assigned_to}</td>
                        <td>{rmData?.status}</td>
                        <td><a class="btn btn-transparent" href={`/dashboard/rm-view/`+rmData?.id}>View Details</a></td>
                        
                      </tr>
                    
                  )))}
                  </tbody>
                  </table>
                : null }
                
              </div>
            
              
          </PanelCardWithHeading>
        ))}

            {/* Messages end */}

        {/* <PanelCardWithHeading title={localization.raisedTicketsDetails}>
          <TableSection
            data={listData}
            headers={headers}
            detailList={listData}
          />
        </PanelCardWithHeading> */}
        <ComplaintReplySupport
                showFilter={showFilter}
                filterToggle={filterToggle}
                viewDropdown={getAllIssuesListing}
                subIssueDropdown={subIssueDropdown}
                getSubIssueDropdown={getSubIssueDropdown}
                internalStatus={internalStatus}
                applyFilter={(val) => applyFilter(val)}
                statusId={'1,2,3'}
                documentUploadUrlPublic={documentUploadUrlPublic}
                documentUrlDataPublic={documentUrlDataPublic}
                source = {'LeadX'}
                // listFilterData={siteFilters?.site_types ? siteFilters : null}
                // siteFilters
            />
      </Layout>


    <>
    <div className="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"      aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
          <div className={`modal-header ${'assign-pop-up'}`}>
              <h5 className="modal-title" id="exampleModalLongTitle">Assigned To</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {internalStatus === "CT Pending" ? (
                <DropDownInput
                  data={[
                    { id: 'L2 Pending', name: 'L2 Pending' }
                  ]}
                  label={localization.assignTo}
                  required
                  errorMsg={localization.requiredName}
                  getIdValue={(val) => {
                    setSelectedAssignTo({
                      ...selectedAssignTo,
                      assigned_to: val.id,
                    });
                  }}
                  isStarRequired={true}
                />
              ) : internalStatus === "L2 Pending" ? (
                <DropDownInput
                  data={[
                    { id: 'CT Pending', name: 'CT Pending' }
                  ]}
                  label={localization.assignTo}
                  required
                  errorMsg={localization.requiredName}
                  getIdValue={(val) => {
                    setSelectedAssignTo({
                      ...selectedAssignTo,
                      assigned_to: val.id,
                    });
                  }}
                  isStarRequired={true}
                />
              ) : null}

                <TextAreaInput
                  name="message"
                  type="text"
                  rows={2}
                  className={`inline-css scrollbar-styling`}
                  label={'Assignee Remark'}
                  value={selectedAssignTo?.assignee_remark}
                  inputValue={selectedAssignTo?.assignee_remark}
                  handleChange={(e) => setSelectedAssignTo({ ...selectedAssignTo, assignee_remark: e.target.value })}
                />
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary d-none d-md-inline-block" data-dismiss="modal">Close</button>
              <button type="button" className="btn btn-primary d-none d-md-inline-block" onClick={handleAssignToSubmit}>Assign</button>
            </div>
          </div>
        </div>
      </div>
    </>
  

      <ModalPop
        title={localization.conf}
        show={isConfirmation}
        handleModalHide={handleIsConfirmation}
      >
        <div className="text-center">
          <h4>{localization.closeComplainConfirmation}</h4>
          <div className="form-group btn-group">
            <Button
              onClick={handleIsConfirmation}
              className="btn btn-transparent"
            >
              {localization.cancel}
            </Button>
            <Button onClick={handleCloseComplain} className="btn btn-primary">
              {localization.continue}
            </Button>
          </div>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.success}
        show={isSuccess}
        handleModalHide={handleIsSuccess}
      >
        {successIconBox()}
      </ModalPop>
      <ModalPop
        title={localization.success}
        show={isReply}
        handleModalHide={handleIsReply}
      >
        <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>
          Success
        </h5>
        <Button
            className="btn btn-primary mb-4"
            onClick={() => handleIsReply()}
          >
            Close
          </Button>
       
      </div>
      </ModalPop>

      <ModalPop
        title={localization.success}
        show={isReply}
        handleModalHide={handleIsReply}
      >
        <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>
          Success
        </h5>
        <Button
            className="btn btn-primary mb-4"
            onClick={() => handleIsReply()}
          >
            Close
          </Button>
       
      </div>
      </ModalPop>
    </Fragment>
  );
};
ViewIssue.propTypes = {
  fetchComplainList: propTypes.func,
};
export default ViewIssue;